import { render } from "./FlavorSelectorModal.vue?vue&type=template&id=63beae57&scoped=true"
import script from "./FlavorSelectorModal.vue?vue&type=script&lang=js"
export * from "./FlavorSelectorModal.vue?vue&type=script&lang=js"

import "./FlavorSelectorModal.vue?vue&type=style&index=0&id=63beae57&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-63beae57"

export default script